export default {
    submitBtnContainer: {
        textAlign: "center",
    }
}